import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import Dashboard from "../../components/dashboard/dashboardPartials/Dashboard";
import { useGeneral } from "../../components/contexts/GeneralContext";
import { useEffect, useState, useCallback } from "react";
import axios from "../../config/axios";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";

const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();

  // ✅ Make the API call reusable
  const fetchDashboardContent = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.get("/dashboard/content");
      setContent(data?.item || null);
      localStorage.setItem("unreadMessagesCount",JSON.stringify(data?.item?.unreadNotificationsCount))
    } catch (err) {
      console.error(err);
      setError("Failed to load dashboard content. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardContent();
  }, [fetchDashboardContent]);

  return { content, loading, error, discountCoupons, fetchDashboardContent };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const MyAccountPage = () => {
  const { content, loading, error, discountCoupons, fetchDashboardContent } = usePageContent();
  useScrollToTop();

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper
            component={
              !loading && error ? (
                <ApiErrorMessage
                  message1="Failed to load content"
                  message2="Please check your connection and try again."
                />
              ) : !loading && !content ? (
                <NoItemsFound
                  message1="Dashboard content unavailable"
                  message2="Please check back later."
                />
              ) : (
                // ✅ Pass the refresh function down
                <Dashboard account={content} onRefresh={fetchDashboardContent} />
              )
            }
          />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default MyAccountPage;
